function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import OrientedCoordinateArray from '../noding/OrientedCoordinateArray';
import ArrayList from '../../../../java/util/ArrayList';
import TreeMap from '../../../../java/util/TreeMap';
var EdgeList = /*#__PURE__*/function () {
  function EdgeList() {
    _classCallCheck(this, EdgeList);
    EdgeList.constructor_.apply(this, arguments);
  }
  return _createClass(EdgeList, [{
    key: "print",
    value: function print(out) {
      out.print('MULTILINESTRING ( ');
      for (var j = 0; j < this._edges.size(); j++) {
        var e = this._edges.get(j);
        if (j > 0) out.print(',');
        out.print('(');
        var pts = e.getCoordinates();
        for (var i = 0; i < pts.length; i++) {
          if (i > 0) out.print(',');
          out.print(pts[i].x + ' ' + pts[i].y);
        }
        out.println(')');
      }
      out.print(')  ');
    }
  }, {
    key: "addAll",
    value: function addAll(edgeColl) {
      for (var i = edgeColl.iterator(); i.hasNext();) {
        this.add(i.next());
      }
    }
  }, {
    key: "findEdgeIndex",
    value: function findEdgeIndex(e) {
      for (var i = 0; i < this._edges.size(); i++) {
        if (this._edges.get(i).equals(e)) return i;
      }
      return -1;
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this._edges.iterator();
    }
  }, {
    key: "getEdges",
    value: function getEdges() {
      return this._edges;
    }
  }, {
    key: "get",
    value: function get(i) {
      return this._edges.get(i);
    }
  }, {
    key: "findEqualEdge",
    value: function findEqualEdge(e) {
      var oca = new OrientedCoordinateArray(e.getCoordinates());
      var matchEdge = this._ocaMap.get(oca);
      return matchEdge;
    }
  }, {
    key: "add",
    value: function add(e) {
      this._edges.add(e);
      var oca = new OrientedCoordinateArray(e.getCoordinates());
      this._ocaMap.put(oca, e);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeList;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { EdgeList as default };
EdgeList.constructor_ = function () {
  this._edges = new ArrayList();
  this._ocaMap = new TreeMap();
};